import { auth } from "@Firebase/firebase";
import axios from "axios";

export const sendPasswordResetEmail =
  (): ((request: { email: string }) => Promise<string>) => async (request) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.post(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/send_password_reset_email/`,
      request,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.result;
  };
